import { render, staticRenderFns } from "./threeList.vue?vue&type=template&id=587ddb4d"
import script from "./threeList.vue?vue&type=script&lang=js"
export * from "./threeList.vue?vue&type=script&lang=js"
import style0 from "./threeList.vue?vue&type=style&index=0&id=587ddb4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports